import React, { Fragment } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../../styles/lrf.scss'

const Lrf = (props) => {
    const setLrf = (bimestre) => {
        switch (bimestre) {
            case "1bim":
                return "1º Bimestre"
                break;
            case "2bim":
                return "2º Bimestre"
                break;
            case "3bim":
                return "3º Bimestre"
                break;
            case "4bim":
                return "4º Bimestre"
                break;
            case "5bim":
                return "5º Bimestre"
                break;
            case "6bim":
                return "6º Bimestre"
                break;
            case "1sem":
                return "1º Semestre"
                break;
            case "2sem":
                return "2º Semestre"
                break;
            case "1qua":
                return "1º Quadrimestre"
                break;
            case "2qua":
                return "2º Quadrimestre"
                break;
            case "3qua":
                return "3º Quadrimestre"
                break;
            case "ano":
                return "Anual"
                break;
        }
    }
    const configLrf = (lrf) => {
        var finalLrf = []
        if (lrf.rreo) {
            if (lrf.rreo.rreo1a !== "false" && lrf.rreo.rreo1a !== false && lrf.rreo.rreo1a !== undefined) {
                const urlRreo1a = `/transparencia${lrf.rreo.rreo1a}`
                finalLrf.push(<Fragment><a href={urlRreo1a} target="_blank" rel="noreferrer">BALANÇO ORÇAMENTÁRIO 1</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo1b !== "false" && lrf.rreo.rreo1b !== false && lrf.rreo.rreo1b !== undefined) {
                const urlRreo1b = `/transparencia${lrf.rreo.rreo1b}`
                finalLrf.push(<Fragment><a href={urlRreo1b} target="_blank" rel="noreferrer">BALANÇO ORÇAMENTÁRIO 2</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo2 !== "false" && lrf.rreo.rreo2 !== false && lrf.rreo.rreo2 !== undefined) {
                const urlRreo2 = `/transparencia${lrf.rreo.rreo2}`
                finalLrf.push(<Fragment><a href={urlRreo2} target="_blank" rel="noreferrer">DEMONSTRATIVO DA EXECUÇÃO DAS DESPESAS POR FUNÇÃO / SUBFUNÇÃO</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo3 !== "false" && lrf.rreo.rreo3 !== false && lrf.rreo.rreo3 !== undefined) {
                const urlRreo3 = `/transparencia${lrf.rreo.rreo3}`
                finalLrf.push(<Fragment><a href={urlRreo3} target="_blank" rel="noreferrer">DEMONSTRATIVO DA RECEITA CORRENTE LÍQUIDA</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo4 !== "false" && lrf.rreo.rreo4 !== false && lrf.rreo.rreo4 !== undefined) {
                const urlRreo4 = `/transparencia${lrf.rreo.rreo4}`
                finalLrf.push(<Fragment><a href={urlRreo4} target="_blank" rel="noreferrer">DEMONSTRATIVO DAS RECEITAS E DESPESAS PREVIDENCIÁRIAS DO REGIME PRÓPRIO DOS SERVIDORES PÚBLICOS</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo5 !== "false" && lrf.rreo.rreo5 !== false && lrf.rreo.rreo5 !== undefined) {
                const urlRreo5 = `/transparencia${lrf.rreo.rreo5}`
                finalLrf.push(<Fragment><a href={urlRreo5} target="_blank" rel="noreferrer">DEMONSTRATIVO DO RESULTADO NOMINAL</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo6 !== "false" && lrf.rreo.rreo6 !== false && lrf.rreo.rreo6 !== undefined) {
                const urlRreo6 = `/transparencia${lrf.rreo.rreo6}`
                finalLrf.push(<Fragment><a href={urlRreo6} target="_blank" rel="noreferrer">DEMONSTRATIVO DO RESULTADO NOMINAL</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo7 !== "false" && lrf.rreo.rreo7 !== false && lrf.rreo.rreo7 !== undefined) {
                const urlRreo7 = `/transparencia${lrf.rreo.rreo7}`
                finalLrf.push(<Fragment><a href={urlRreo7} target="_blank" rel="noreferrer">DEMONSTRATIVO DOS RESTOS A PAGAR POR PODER E ÓRGÃO</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo8 !== "false" && lrf.rreo.rreo8 !== false && lrf.rreo.rreo8 !== undefined) {
                const urlRreo8 = `/transparencia${lrf.rreo.rreo8}`
                finalLrf.push(<Fragment><a href={urlRreo8} target="_blank" rel="noreferrer">DEMONSTRATIVO DAS RECEITAS E DESPESAS COM MANUTENÇÃO E DESENVOLVIMENTO DO ENSINO</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo9 !== "false" && lrf.rreo.rreo9 !== false && lrf.rreo.rreo9 !== undefined) {
                const urlRreo9 = `/transparencia${lrf.rreo.rreo9}`
                finalLrf.push(<Fragment><a href={urlRreo9} target="_blank" rel="noreferrer">DEMONSTRATIVO DAS RECEITAS DE OPERAÇÕES DE CRÉDITO E DESPESAS DE CAPITAL</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo10 !== "false" && lrf.rreo.rreo10 !== false && lrf.rreo.rreo10 !== undefined) {
                const urlRreo10 = `/transparencia${lrf.rreo.rreo10}`
                finalLrf.push(<Fragment><a href={urlRreo10} target="_blank" rel="noreferrer">DEMONSTRATIVO DA PROJEÇÃO ATUARIAL DO REGIME PRÓPRIO DE PREVIDÊNCIA SOCIAL DOS SERVIDORES PÚBLICOS</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo11 !== "false" && lrf.rreo.rreo11 !== false && lrf.rreo.rreo11 !== undefined) {
                const urlRreo11 = `/transparencia${lrf.rreo.rreo11}`
                finalLrf.push(<Fragment><a href={urlRreo11} target="_blank" rel="noreferrer">DEMONSTRATIVO DA RECEITA DE ALIENAÇÃO DE ATIVOS E APLICAÇÃO DOS RECURSOS</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo12 !== "false" && lrf.rreo.rreo12 !== false && lrf.rreo.rreo12 !== undefined) {
                const urlRreo12 = `/transparencia${lrf.rreo.rreo12}`
                finalLrf.push(<Fragment><a href={urlRreo12} target="_blank" rel="noreferrer">DEMONSTRATIVO DAS RECEITAS DE IMPOSTOS E DAS DESPESAS PRÓPRIAS COM SAÚDE</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo13 !== "false" && lrf.rreo.rreo13 !== false && lrf.rreo.rreo13 !== undefined) {
                const urlRreo13 = `/transparencia${lrf.rreo.rreo13}`
                finalLrf.push(<Fragment><a href={urlRreo13} target="_blank" rel="noreferrer">DEMONSTRATIVO DAS PARCERIAS PÚBLICO-PRIVADAS</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo14 !== "false" && lrf.rreo.rreo14 !== false && lrf.rreo.rreo14 !== undefined) {
                const urlRreo14 = `/transparencia${lrf.rreo.rreo14}`
                finalLrf.push(<Fragment><a href={urlRreo14} target="_blank" rel="noreferrer">DEMONSTRATIVO SIMPLIFICADO</a><br /></Fragment>)
            }
            if (lrf.rreo.rreo15 !== "false" && lrf.rreo.rreo15 !== false && lrf.rreo.rreo15 !== undefined) {
                const urlRreo15 = `/transparencia${lrf.rreo.rreo15}`
                finalLrf.push(<Fragment><a href={urlRreo15} target="_blank" rel="noreferrer">-</a> <br /></Fragment>)
            }
            if (lrf.rreo.rreo16 !== "false" && lrf.rreo.rreo16 !== false && lrf.rreo.rreo16 !== undefined) {
                const urlRreo16 = `/transparencia${lrf.rreo.rreo16}`
                finalLrf.push(<Fragment><a href={urlRreo16} target="_blank" rel="noreferrer">-</a> <br /></Fragment>)
            }
        }
        if (lrf.rgf) {
            if (lrf.rgf.rgf1 !== "false" && lrf.rgf.rgf1 !== false && lrf.rgf.rgf1 !== undefined) {
                const urlRgf1 = `/transparencia${lrf.rgf.rgf1}`
                finalLrf.push(<Fragment><a href={urlRgf1} target="_blank" rel="noreferrer">DEMONSTRATIVO DA DESPESA COM PESSOAL</a><br /></Fragment>)
            }
            if (lrf.rgf.rgf2 !== "false" && lrf.rgf.rgf2 !== false && lrf.rgf.rgf2 !== undefined) {
                const urlRgf2 = `/transparencia${lrf.rgf.rgf2}`
                finalLrf.push(<Fragment><a href={urlRgf2} target="_blank" rel="noreferrer">DEMONSTRATIVO DA DÍVIDA CONSOLIDADA</a><br /></Fragment>)
            }
            if (lrf.rgf.rgf3 !== "false" && lrf.rgf.rgf3 !== false && lrf.rgf.rgf3 !== undefined) {
                const urlRgf3 = `/transparencia${lrf.rgf.rgf3}`
                finalLrf.push(<Fragment><a href={urlRgf3} target="_blank" rel="noreferrer">DEMONSTRATIVO DAS GARANTIAS E CONTRAGARANTIAS DE VALORES</a><br /></Fragment>)
            }
            if (lrf.rgf.rgf4 !== "false" && lrf.rgf.rgf4 !== false && lrf.rgf.rgf4 !== undefined) {
                const urlRgf4 = `/transparencia${lrf.rgf.rgf4}`
                finalLrf.push(<Fragment><a href={urlRgf4} target="_blank" rel="noreferrer">DEMONSTRATIVO DAS OPERAÇÕES DE CRÉDITO</a><br /></Fragment>)
            }
            if (lrf.rgf.rgf5 !== "false" && lrf.rgf.rgf5 !== false && lrf.rgf.rgf5 !== undefined) {
                const urlRgf5 = `/transparencia${lrf.rgf.rgf5}`
                finalLrf.push(<Fragment><a href={urlRgf5} target="_blank" rel="noreferrer">DEMONSTRATIVO DA DISPONIBILIDADE DE CAIXA E DOS RESTOS A PAGAR</a><br /></Fragment>)
            }
            if (lrf.rgf.rgf6 !== "false" && lrf.rgf.rgf6 !== false && lrf.rgf.rgf6 !== undefined) {
                const urlRgf6 = `/transparencia${lrf.rgf.rgf6}`
                finalLrf.push(<Fragment><a href={urlRgf6} target="_blank" rel="noreferrer">DEMONSTRATIVO DOS RESTOS A PAGAR</a><br /></Fragment>)
            }
            if (lrf.rgf.rgf7 !== "false" && lrf.rgf.rgf7 !== false && lrf.rgf.rgf7 !== undefined) {
                const urlRgf7 = `/transparencia${lrf.rgf.rgf7}`
                finalLrf.push(<Fragment><a href={urlRgf7} target="_blank" rel="noreferrer">DEMONSTRATIVO SIMPLIFICADO</a><br /></Fragment>)
            }
            if (lrf.rgf.rgf8 !== "false" && lrf.rgf.rgf8 !== false && lrf.rgf.rgf8 !== undefined) {
                const urlRgf8 = `/transparencia${lrf.rgf.rgf8}`
                finalLrf.push(<Fragment><a href={urlRgf8} target="_blank" rel="noreferrer">DEMONSTRATIVO DOS LIMITES</a><br /></Fragment>)
            }
        }
        if (lrf.dcrgf) {
            if (lrf.dcrgf.dcrgf1 !== "false" && lrf.dcrgf.dcrgf1 !== false && lrf.dcrgf.dcrgf1 !== undefined) {
                const urlDcrgf1 = `/transparencia${lrf.dcrgf.dcrgf1}`
                finalLrf.push(<Fragment><a href={urlDcrgf1} target="_blank" rel="noreferrer">DEMONSTRATIVO DA DESPESA COM PESSOAL</a><br /></Fragment>)
            }
            if (lrf.dcrgf.dcrgf2 !== "false" && lrf.dcrgf.dcrgf2 !== false && lrf.dcrgf.dcrgf2 !== undefined) {
                const urlDcrgf2 = `/transparencia${lrf.dcrgf.dcrgf2}`
                finalLrf.push(<Fragment><a href={urlDcrgf2} target="_blank" rel="noreferrer">-</a><br /></Fragment>)
            }
            if (lrf.dcrgf.dcrgf3 !== "false" && lrf.dcrgf.dcrgf3 !== false && lrf.dcrgf.dcrgf3 !== undefined) {
                const urlDcrgf3 = `/transparencia${lrf.dcrgf.dcrgf3}`
                finalLrf.push(<Fragment><a href={urlDcrgf3} target="_blank" rel="noreferrer">-</a><br /></Fragment>)
            }
            if (lrf.dcrgf.dcrgf4 !== "false" && lrf.dcrgf.dcrgf4 !== false && lrf.dcrgf.dcrgf4 !== undefined) {
                const urlDcrgf4 = `/transparencia${lrf.dcrgf.dcrgf4}`
                finalLrf.push(<Fragment><a href={urlDcrgf4} target="_blank" rel="noreferrer">-</a><br /></Fragment>)
            }
            if (lrf.dcrgf.dcrgf5 !== "false" && lrf.dcrgf.dcrgf5 !== false && lrf.dcrgf.dcrgf5 !== undefined) {
                const urlDcrgf5 = `/transparencia${lrf.dcrgf.dcrgf5}`
                finalLrf.push(<Fragment><a href={urlDcrgf5} target="_blank" rel="noreferrer">DEMONSTRATIVO DA DISPONIBILIDADE DE CAIXA E DOS RESTOS A PAGAR</a><br /></Fragment>)
            }
            if (lrf.dcrgf.dcrgf6 !== "false" && lrf.dcrgf.dcrgf6 !== false && lrf.dcrgf.dcrgf6 !== undefined) {
                const urlDcrgf6 = `/transparencia${lrf.dcrgf.dcrgf6}`
                finalLrf.push(<Fragment><a href={urlDcrgf6} target="_blank" rel="noreferrer">DEMONSTRATIVO DOS RESTOS A PAGA</a><br /></Fragment>)
            }
            if (lrf.dcrgf.dcrgf7 !== "false" && lrf.dcrgf.dcrgf7 !== false && lrf.dcrgf.dcrgf7 !== undefined) {
                const urlDcrgf7 = `/transparencia${lrf.dcrgf.dcrgf7}`
                finalLrf.push(<Fragment><a href={urlDcrgf7} target="_blank" rel="noreferrer">-</a><br /></Fragment>)
            }
            if (lrf.dcrgf.dcrgf8 !== "false" && lrf.dcrgf.dcrgf8 !== false && lrf.dcrgf.dcrgf8 !== undefined) {
                const urlDcrgf8 = `/transparencia${lrf.dcrgf.dcrgf8}`
                finalLrf.push(<Fragment><a href={urlDcrgf8} target="_blank" rel="noreferrer">DEMONSTRATIVO DOS LIMITES</a><br /></Fragment>)
            }
        }
        return finalLrf
    }


    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>{setLrf(props.lrf.bimestre)}/{props.lrf.ano}</h5></Card.Header>
                    <Card.Body>
                        <Card.Text>
                            <h5>Anexos</h5>
                            {configLrf(props.lrf)}
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Lrf;